var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollaspeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Collaspe_icon",
    "data-name": "Collaspe icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_22",
    "data-name": "Polygon 22",
    d: "M7,0l7,9H0Z",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaspeicon);
export default __webpack_public_path__ + "static/media/Collaspe icon.747ba2c251f670a62eea0b4ff24c03f3.svg";
export { ForwardRef as ReactComponent };